// import Vue from 'vue'
import store from "@/front/stores/front";
import devis from "@/components/features/ProductPageDevis"
import AccessoiresCompatibles from "@/front/components/product/AccessoiresCompatibles";

Vue.prototype.$appName = 'ppdVm';

document.addEventListener('DOMContentLoaded', function () {
  global.ppdVm = new Vue({
    store,
    el: '#product-page-devis',
    render: h => h(devis)
  });
  const compatibleTab = document.getElementById('tab-title-compatibles')
  compatibleTab.addEventListener('click', function (event) {
    new Vue({
      store,
      el: '.compatible__products',
      render: h => h(AccessoiresCompatibles)
    });
  }, {once: true})
});

